export default "__VITE_ASSET__DtMONiIq__"